if(!customElements.get('product-information')) {
  customElements.define(
    'product-information',
    class ProductInformation extends HTMLElement {
      tabs = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.init();
      }

      init() {
        if(!this.tabs?.length > 0) {
          return console.error('Product Info cannot be initialized, no tab was found.');
        }

        this.tabs.forEach(tab => {
          tab.addEventListener('click', this.handleTabClick.bind(this));
        });
      }

      handleTabClick(event) {
        this.desactivateLastTab();
        event.currentTarget.classList.add('active');
        this.querySelector(`[data-content="${event.currentTarget.dataset.tab}"]`).classList.add('active');
      }

      desactivateLastTab() {
        const activeTab = this.querySelector('[data-tab].active');
        if(activeTab) activeTab.classList.remove('active');

        const activeContent = this.querySelector('[data-content].active');
        if(activeContent) activeContent.classList.remove('active');
      }
    }
  );
}